<template>
  <div v-if="loaded">
    <div v-if="details">
      <router-link :to="{name: 'creditorView', params: { id: creditor.ID }}">{{creditor.name}}</router-link> / <router-link :to="{name: 'debtorView', params: { id: debtor.ID }}">{{debtor.name}}</router-link>
    </div>
    <b-progress
      class="mt-2 mb-2"
      height="2rem"
      :max="summary['Total dû'].total"
      show-value
    >
      <b-progress-bar
        :precision="2"
        :value="summary['Total des paiements'].total"
        :label="`${summary['Total des paiements'].total} €`"
        variant="success"
      >
      </b-progress-bar>
      <b-progress-bar
        :precision="2"
        :value="summary['Solde restant dû'].total"
        :label="`${summary['Solde restant dû'].total} €`"
        variant="danger"
      ></b-progress-bar>
    </b-progress>
    <p></p>
    <b-table
      
      v-if="liste.length > 0"
      small
      id="summaryTable"
      striped
      fixed
      hover
      :fields="summaryFields"
      :items="liste"
    >
      <template v-slot:cell(total)="data"
        >{{ twoDigits(data.item.total) }} €</template
      >
      
    </b-table>
  </div>
</template>

<script>
import DateTime from "@/services/DateTime.js";
import warrants from "@/services/warrants.js";
export default {
  name: "warrant-summary",
  props: {
    id: {
      type: [String, Number]
    }, 
    details: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      loaded: false,
      summary: {},
      liste: [],
      summaryFields: [
        {
          key: "label",
          label: "",
          sortable: true,
          thStyle: {width: '300px'}
        },

        {
          key: "total",
          label: "Total",
          sortable: true,
          class: "text-left",
        },
      ],
    };
  },
  created() {
    warrants.summary(this.$props.id).then((response) => {
      this.summary = response.data.summary;
      this.loaded = true;
      Object.entries(this.summary).forEach(el => {
        this.liste.push({
          label: el[0],
          nombre: el[1].nombre,
          total: el[1].total
        });
      });
      this.creditor = response.data.creditor;
      this.debtor = response.data.debtor;
    });
  },
  methods: {
    toDate(d) {
      return DateTime.humanDate(d);
    },
    twoDigits(value) {
      return Number(value).toFixed(2);
    },
  },
};
</script>

<style lang="scss" scoped>
</style>